
export default function Footer() {
  return (
    <footer className="bg-white text-[#1B3A6B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/7da722d1075287828d0f792d894e39bf.jpeg" 
              alt="Voltis Florida Home Services" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-[#1B3A6B]/60 mb-4 leading-relaxed">
              Florida's trusted provider of plumbing, heating, air conditioning, water quality, and electrical services. Available 24/7 for all your home service needs.
            </p>
            <div className="flex space-x-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center hover:bg-[#B22234] hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center hover:bg-[#B22234] hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center hover:bg-[#B22234] hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center hover:bg-[#B22234] hover:text-white transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li><a href="#services" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Air Conditioning</a></li>
              <li><a href="#services" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Heating Services</a></li>
              <li><a href="#services" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Plumbing</a></li>
              <li><a href="#services" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Water Quality</a></li>
              <li><a href="#services" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Electrical</a></li>
              <li><a href="#offers" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Maintenance Plans</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#why-choose-us" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">About Us</a></li>
              <li><a href="#service-areas" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Service Areas</a></li>
              <li><a href="#offers" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Special Offers</a></li>
              <li><a href="#contact" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Contact Us</a></li>
              <li><a href="#" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Careers</a></li>
              <li><a href="#" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Blog</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-fill text-[#B22234] mt-1"></i>
                <div>
                  <p className="text-sm text-[#1B3A6B]/60">24/7 Emergency</p>
                  <a href="tel:+18005551234" className="text-sm font-semibold hover:text-[#B22234] transition-colors">
                    (800) 555-1234
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-fill text-[#B22234] mt-1"></i>
                <div>
                  <p className="text-sm text-[#1B3A6B]/60">Email</p>
                  <a href="mailto:info@voltisflorida.com" className="text-sm font-semibold hover:text-[#B22234] transition-colors">
                    info@voltisflorida.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-[#B22234] mt-1"></i>
                <div>
                  <p className="text-sm text-[#1B3A6B]/60">Serving All of Florida</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1B3A6B]/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-[#1B3A6B]/60">
              © 2024 Voltis. All rights reserved. | Licensed &amp; Insured
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Privacy Policy</a>
              <a href="#" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-[#1B3A6B]/60 hover:text-[#B22234] transition-colors">
                Web Design
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
